import * as React from 'react';
import styled from 'styled-components';

const createMarkup = (answer) => {
  return { __html: answer };
};

const Answer = ({ answer }) => {

  return (
    <Container className="content-placeholder">
      <p dangerouslySetInnerHTML={createMarkup(answer)} />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 1.25rem 3rem;
  font-size: 1rem;
`;

export default Answer;
